import axios from 'axios';

const instance = axios.create({
  baseURL: '/',
  timeout: 0,
  withCredentials: true,
});

export default instance;
